import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

class ManagedSelectInput extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    includeBlank: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.string,
    ]),
    name: PropTypes.string,
    plain: PropTypes.bool,
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    onValueChange: PropTypes.func.isRequired
  }

  handleChange = (event) => {
    this.props.onChange({ [this.props.name]: event.target.value }, event);
    this.props.onValueChange(event.target.value, event);
  }

  render() {
    const { className, includeBlank, plain, value, onChange, onValueChange, ...props } = this.props;
    const blankOption = (<option disabled hidden value="">
      {typeof includeBlank === 'string' ? includeBlank : 'Select...'}
    </option>);
    const inputProps = {
      ...props,
      value: value || '',
      onChange: this.handleChange
    };

    delete inputProps.type;

    return (
      <select className={classNames(className, { 'form-select': !plain })} {...inputProps}>
        {includeBlank && blankOption}
        {this.props.children}
      </select>
    );
  }
}

export default ManagedSelectInput;
